export const templateComps = {
  confirmModal: {
    cancel: "Cancel",
    delete: "Delete",
  },
  channexIncident: {
    kicker: "Important notice",
    brandTitle: "External incident",
    closeLabel: "Close notice",
    subtitle:
      "We're monitoring the situation and will review synchronization once the service is restored.",
    title:
      "General incident connecting with Booking / Airbnb / external channel manager",
    lead: "Hi, we're detecting a general incident with our external OTA synchronization provider.",
    text: "This incident affects their API and may delay the synchronization of bookings, availability and date closures.",
    note: "As soon as the connection is back up, we'll review data synchronization to verify bookings, availability and date closures.",
    textLast:
      "At WA Checkin we'll review synchronization once the service is operational again.",
    button: "Got it",
  },
  notificationsNav: {
    title: "Notifications",
    recent: "recent",
    emptyTitle: "No notifications",
    emptyText:
      "When something important happens with your bookings, it will appear here.",
    seeAll: "View all notifications",
    meta: {
      t1: { status: "New", category: "booking" },
      t2: { status: "Updated", category: "booking" },
      t3: { status: "Cancelled", category: "booking" },
      t4: { status: "Completed", category: "check-in" },
      t5: { status: "Requested", category: "service" },
      t6: { status: "Received", category: "request" },
      t7: { status: "Approved", category: "request" },
      t8: { status: "Rejected", category: "request" },
      t9: { status: "Confirmed", category: "payment" },
      t10: { status: "Awaiting payment", category: "pending payment" },
      t11: { status: "Assign room", category: "booking" },
      t12: { status: "Delivery failed", category: "check-in" },
      t13: { status: "Not sent", category: "traveler registration" },
      t15: { status: "Active", category: "subscription" },
      default: { status: "Notice", category: "system" },
    },
    typeLabel: {
      t1: "NEW BOOKING",
      t2: "BOOKING UPDATED",
      t3: "BOOKING CANCELLED",
      t4: "CHECK-IN",
      t5: "SERVICE",
      t6: "REQUEST",
      t7: "REQUEST APPROVED",
      t8: "REQUEST REJECTED",
      t10: "AWAITING PAYMENT",
      t11: "ASSIGN ROOM",
      t12: "DELIVERY FAILED",
      t13: "TRAVELER REGISTRATION",
      t15: "SUBSCRIPTION ACTIVE",
      default: "NOTIFICATION",
    },
  },
};
